//1 )  representa lo que se va almacenar globalmente 
export const initialState = {
    LoadComponent: false,
    texto: ''
}

//2) logica de como se va almacenar y manejar lo que se va guardar 
const cargandoReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOAD_COMP":
            return {
                ...state,
                LoadComponent: true,
                texto: action.texto
            }
        case "CLOSE_LOAD_COMP":
            return {
                ...state,
                LoadComponent: false
            }
        default: return state;
    }
};

//3) Se exporta 
export default cargandoReducer;